import { useCallback } from 'react';

export function useMatomoPathname() {
  const parseProfilePathname = useCallback((path: string) => {
    const pathItems = path.split('/').filter(Boolean);
    const subs = pathItems.slice(pathItems.indexOf('app') + 1, pathItems.length);
    if (subs.includes('users')) {
      const subLength = subs.length;

      if (subLength === 2) {
        return 'User profile (rooter)';
      }

      if (subLength >= 3) {
        const segment2 = subs[2];

        switch (segment2) {
          case 'overview':
            return 'User overview';
          case 'kyckyb':
            return 'User kyckyb';
          case 'children':
            return 'User children';
          case 'company-members':
            return 'User company members';
          case 'wallets':
            if (subLength === 3) {
              return 'User wallets (rooter)';
            }
            return 'User wallets';
          case 'cards':
            if (subLength === 3) {
              return 'User cards (rooter)';
            }
            return 'User cards';
          case 'beneficiaries':
            return 'User beneficiaries';
          default:
            break;
        }
      }
    }

    return subs.join(' ');
  }, []);

  return { parseProfilePathname };
}
